import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { flowListFilterSetShowPending } from '../../app/actions/flowListFilterActions';
import useActiveSpecialistRole from '../../app/hooks/useActiveSpecialistRole';

const FlowModuleListFilterBar = ({
  visible = false,
  showRejected = false,
  roleLabel = '',
  onShowRejectedChange
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { roleKey } = useActiveSpecialistRole();
  const showRejectedToggle = roleKey === 'validator';

  useEffect(() => {
    dispatch(flowListFilterSetShowPending(false));
  }, [dispatch]);

  if (!visible || !showRejectedToggle) {
    return null;
  }

  return (
    <div className="d-flex flex-wrap align-items-center gap-3 mb-2 px-3 px-md-4">
      <div className="form-check form-switch mb-0">
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            id="flow-list-show-rejected"
            checked={showRejected}
            onChange={(event) => onShowRejectedChange?.(event.target.checked)}
          />
          <label className="form-check-label small" htmlFor="flow-list-show-rejected">
            {t('flow.list-filter.show-rejected', 'Mostrar rechazados')}
          </label>
        </div>
    </div>
  );
};

FlowModuleListFilterBar.propTypes = {
  visible: PropTypes.bool,
  showRejected: PropTypes.bool,
  roleLabel: PropTypes.string,
  onShowRejectedChange: PropTypes.func
};

export default FlowModuleListFilterBar;
